<script>
import resources from './resources'
import SlideUpDown from 'vue-slide-up-down'

export default {
  name: 'gadget-staff',
  mixins: [resources],
  components: {
    SlideUpDown
  }
}
</script>

<template lang="pug">
  page(title="Bem-vindo(a) ao Medibook!")
    div
      .clearfix
      section#apresentacao.container-fluid.m-top-120(v-if="loading")
        .loading-screen(v-show='loading', v-bind:class='classes', v-bind:style='{backgroundColor:bc}')
            component(v-if='customLoader', v-bind:is='customLoader')
            div(v-else='')
              .loading-circle
              p.loading-text
                strong {{text}}

      section#apresentacao.container-fluid.m-top-120(role='definition', v-if="!loading")
        //- Caso ainda não tenha perfil no medibook
        .container.professional-public(v-if="noProfilePublic")
          div.text-center
            h2.center
              br
              |Esta Clínica ainda não tem um perfil no Medibook

        .container.professional-public(v-if="companyProfileProfessionals.length > 0 && profilePublic.length > 0")
          div(style=" padding: 20px;")
            .col-xs-12.professional-profile.col-md-12
              .row
                .row(v-for="profile in profilePublic", style="margin-bottom: 20px;")
                  .row
                    .col-xs-9.col-sm-2.col-md-2
                      div.text-center
                        .profile-photo(v-if="profile.is_company")
                          img.img-circle(:src="profile.avatar_company")
                        .profile-photo(v-if="!profile.is_company")
                          img.img-circle(:src="profile.avatar_company")

                    .col-xs-3.hidden-lg.hidden-sm.hidden-md
                      .row
                        company-statitics(
                            :countryRegister="profile.document"
                            :totalAgendas="totalAgendas",
                            :totalAgendaSchedules="totalAgendaSchedules",
                            :totalProfessional="totalProfessional"
                          )
                    .col-xs-12.col-sm-8.col-md-4.profissional-info.professional-profile-modal-serach
                      h5(style="font-size: 15px;")
                        strong {{ profile.slug }}
                      br
                      //-.info
                        strong {{ profile.speciality }}
                      .info
                        strong {{ profile.slug }}  &mdash; {{ typeClinic(profile.type) }}
                      br
                      .adress(v-for="address in profile.addresses")
                        | {{  address.street }}, {{ address.number }} &nbsp;
                        span(v-if="address.complement") - {{ address.complement}}
                        br
                        | {{ address.zip }} - {{ address.district }} - {{ address.city}} - {{ address.state }}

                    .col-xs-12.col-sm-2.col-md-6.hidden-xs
                      .row
                        span(style="float: right;")
                          company-statitics(
                              :countryRegister="profile.document"
                              :totalAgendas="totalAgendas",
                              :totalAgendaSchedules="totalAgendaSchedules",
                              :totalProfessional="totalProfessional"
                            )

                  hr
                  .row
                    .col-xs-12.col-sm-9
                        p.text-right.mt-lg
                              span(style="float: left")
                                span.covenants
                                strong.small-complementary-information Convênios
                              br
                              #planos(v-if="operatorCovenant !== null")
                                span(v-for="covenant in profile.covenants", style="float: left", v-if="covenant.covenant.name.trim() === operatorCovenant")
                                  | {{ covenant.covenant.slug }}

                              #planos(v-if="operatorCovenant === null")
                                //- Ajustado para sanepar
                                span(v-for="covenant in profile.covenants", style="float: left", :title='covenant.covenant.name', v-tooltip.bottom-star="'teste'")
                                    | {{ covenant.covenant.slug }}

                    .col-xs-12.col-sm-3.m-top-15
                      p.text-right.mt-lg
                          span(style="float: left")
                            span.covenants
                            strong.small-complementary-information Fotos
                          br

                      .row(v-if="companyProfileProfessionals[0].imagens !== null", style="width: 62px;")
                        silentbox-group
                          silentbox-item(:src='companyProfileProfessionals[0].imagens', :description="profile.slug")
                            .col-xs-6.col-md-3
                              a.thumbnail
                                img(:src='companyProfileProfessionals[0].imagens')

                      .row(v-if="companyProfileProfessionals[0].imagens === null")
                        a.thumbnail
                          img(src='/static/images/img_365-365.png')
      section#results
        .container.professional-public
          .results.col-xs-12
            items(:operator-covenant="operatorCovenant", :item="agenda", v-for="agenda in companyProfileProfessionals", :key="agenda.id", style="margin-bottom: 20px;")

              .row.row-border.professional-profile(v-if="companyProfileProfessionals[0].bio")
                  .col-xs-12.col-sm-12.col-md-12.m-top-20
                    .h5-title
                      h5
                      strong Informações Complementares
                  span(v-for="professionalBio in companyProfileProfessionals.slice(0, 1)", v-if="professionalBio.professional.document !== null")
                    p.ql-editor(v-html="professionalBio.bio")
    .clearfix
    footer#footer.container-fluid
      #to-top(v-scroll-to="'#apresentacao'")
        svg(version='1.1', baseprofile='basic', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/', x='0px', y='0px', width='16.446px', height='7.71px', viewbox='0 0 16.446 7.71', overflow='scroll', enable-background='new 0 0 16.446 7.71', xml:space='preserve')
          defs
          g
            path(fill='#FFFFFF', d='M15.723,7.71c-0.186,0-0.37-0.071-0.512-0.212L9.757,2.044c-0.814-0.817-2.253-0.815-3.067,0L1.234,7.498\
            c-0.282,0.281-0.74,0.281-1.022,0c-0.283-0.283-0.283-0.741,0-1.023l5.455-5.454c1.36-1.36,3.752-1.361,5.113,0l5.454,5.454\
            c0.282,0.283,0.282,0.74,0,1.023C16.093,7.639,15.908,7.71,15.723,7.71z')
      .container
        .row
          .col-sm-10.col-sm-offset-1.col-md-3
            img.logo(src='/static/images/logo.svg')
            p
              | Medibook® é um serviço de agendamento de consultas e eventos de saúde, criado para atender as demandas de saúde existentes e facilitar o acesso à medicina de forma simples e eficiente. Trata-se de um serviço gratuito, sem custo para usuários e profissionais
              | de saúde.
          .col-sm-10.col-sm-offset-1.col-md-2
            .title Mapa do Site
            ul
              a(href='', v-scroll-to="'#apresentacao'")
                li Apresentação
              a(href='', v-scroll-to="'#beneficios'")
                li Benefícios
              a(href='', v-scroll-to="'#contato'")
                li Contato
              a(href='http://app-v1.medibook.com.br/terms/term', target="_blank")
                li Termos de Uso
              a(href='http://app-v1.medibook.com.br/terms/policy', target="_blank")
                li Políticas de Privacidade
          .col-sm-10.col-sm-offset-1.col-md-3
            .title Contato
            //-.phone
            a(href='tel:4135980860', style='color:inherit;text-decoration:none;') &nbsp;
              i.fa.fa-phone &nbsp;
              |41 3598-0860
            a(href='mailto:contato@medibook.com.br', style='color:inherit;text-decoration:none;')
              i.fa.fa-envelope &nbsp;
              |contato@medibook.com.br

            .social
                a(href='')
                  .icon.facebook
                    svg(version='1.1', baseprofile='basic', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/', x='0px', y='0px', width='8.842px', height='18.446px', viewbox='0 0 8.842 18.446', overflow='scroll', enable-background='new 0 0 8.842 18.446', xml:space='preserve')
                      defs
                      path(fill='#2071B6', d='M8.842,3.097c-0.575,0-1.128-0.005-1.68,0.003C6.936,3.103,6.708,3.116,6.486,3.157\
                      C6.055,3.236,5.83,3.473,5.818,3.912C5.799,4.635,5.813,5.358,5.813,6.111c0.905,0,1.836,0,2.799,0\
                      C8.571,6.5,8.535,6.858,8.497,7.215C8.432,7.821,8.36,8.426,8.302,9.033c-0.015,0.156-0.072,0.2-0.225,0.198\
                      C7.396,9.224,6.715,9.228,6.034,9.228c-0.076,0-0.152,0-0.252,0c0,3.086,0,6.146,0,9.218c-1.396,0-2.768,0-4.166,0\
                      c0-3.069,0-6.129,0-9.218c-0.413,0-0.801,0-1.189,0C0,9.228,0,9.228,0,8.803c0-0.809,0-1.617,0-2.426c0-0.077,0-0.153,0-0.251\
                      c0.54,0,1.061,0,1.615,0c0-0.102-0.001-0.184,0-0.266C1.63,5.017,1.616,4.172,1.67,3.331c0.048-0.758,0.264-1.476,0.753-2.086\
                      C2.928,0.615,3.607,0.28,4.38,0.143c0.472-0.084,0.957-0.122,1.437-0.132c0.943-0.02,1.887-0.006,2.83-0.006\
                      c0.062,0,0.125,0.008,0.196,0.013C8.842,1.044,8.842,2.056,8.842,3.097z')
                a(href='')
                  .icon.twitter
                    svg(version='1.1', baseprofile='basic', xmlns='http://www.w3.org/2000/svg', xmlns:xlink='http://www.w3.org/1999/xlink', xmlns:a='http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/', x='0px', y='0px', width='17.446px', height='14.3px', viewbox='0 0 17.446 14.3', overflow='scroll', enable-background='new 0 0 17.446 14.3', xml:space='preserve')
                      defs
                      g
                        path(fill='#00C0F7', d='M0,12.769c1.918,0.104,3.632-0.377,5.15-1.555c-1.076-0.087-1.973-0.511-2.666-1.335\
                        C2.199,9.538,1.983,9.159,1.84,8.705c0.534,0.077,1.041,0.084,1.602-0.083C2.3,8.332,1.474,7.714,0.954,6.716\
                        C0.689,6.208,0.55,5.664,0.571,5.058c0.503,0.244,1.004,0.411,1.578,0.428c-1.604-1.338-1.964-2.928-1.1-4.837\
                        c1.977,2.322,4.439,3.581,7.464,3.8c-0.02-0.181-0.036-0.337-0.055-0.492C8.24,2.175,9.542,0.402,11.312,0.073\
                        c1.248-0.232,2.34,0.084,3.261,0.96c0.1,0.095,0.191,0.095,0.306,0.068c0.666-0.155,1.3-0.394,1.9-0.723\
                        c0.05-0.028,0.102-0.051,0.188-0.094c-0.288,0.829-0.783,1.45-1.473,1.935c0.669-0.046,1.294-0.241,1.906-0.493\
                        c0.015,0.018,0.031,0.036,0.046,0.054c-0.345,0.386-0.681,0.779-1.038,1.153c-0.183,0.192-0.399,0.355-0.611,0.517\
                        c-0.102,0.078-0.131,0.158-0.132,0.285c-0.009,3.477-1.321,6.346-4.047,8.524c-1.408,1.125-3.044,1.742-4.833,1.956\
                        c-2.355,0.282-4.567-0.134-6.621-1.337C0.108,12.846,0.055,12.806,0,12.769z')
        .row
          .hidden-xs.col-sm-10.col-sm-offset-1.copyright
            .pull-left Medibook® - 2018 - Todos os direitos reservados.
            .pull-right
              | 80030-030 Curitiba - PR -&nbsp;
              a(href='tel:4135980860', style='color:inherit;text-decoration:none;display:inline-block') 41 35980860

          .hidden-sm.hidden-lg.col-sm-10.col-sm-offset-1.copyright
            .span.text-center Medibook® - 2018 - Todos os direitos reservados. 80030-030 Curitiba - PR -&nbsp;
              a(href='tel:4135980860', style='color:inherit;text-decoration:none;display:inline-block') 41 3598-0860
</template>
<style scoped>
.loading-screen {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40%;
  width: 100%;
  /* position: fixed; */
  top: 100px;
  left: 0;
  z-index: 300;
  flex-direction: column;
  user-select: none;
  border-radius: 5px;
}
.loading-circle {
  margin-left: 35%;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 2px solid transparent;
  border-left-color: #387ab9;
  animation: circleanimation .45s linear infinite
}
.loading-text {
  margin-top: 15px;
  color: #387ab9;
  font-size: 14px;
  font-weight: 600;
}
@keyframes circleanimation {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(360deg);
  }
}
.m-top-120 {
  margin-top: 120px;
}
#apresentacao {
    background: #f7f7f7;
    /* padding: 30px 0px 60px 0px; */
}
/* startTop */
.professional-public {
    background-color: #fff;
    margin-bottom: 50px;
    text-align: justify;
}

.professional-public h4 {
  font-size: 22px;
}
.professional-profile h5 {
    font-size: 16px;
    color: #2071b9;
    position: relative;
    display: inline-block;
}
.info {
    font-size: 10px;
}
span.crm {
    font-size: 16px;
}

.professional-profile-modal-serach h6 {
    color: #387ab9;
    font-size: 20px;
    height: 0;
}

.professional-profile .profile-photo img {
  width: 90%;
  margin: 4px 10% 0px 10%;
}

.professional-profile .links ul {
  padding-left: 15px;
  height: 50px;
  margin-bottom: 30px;
}

.professional-profile .links ul li {
  display: inline-block;
  width: 33%;
  height: 50px;
  padding: 15px 0px;
  border-bottom: 1px solid #FFF;
}

.professional-profile .links ul li a {
  background: transparent;
}

.professional-profile ul li:hover {
  border-bottom: 1px solid #1384D8;
}

.professional-profile .links ul li img {
  height: 20px;
  width: 100%;
  margin: 0 auto;
}

.professional-profile .profissional-info {
  /* height: 0px; */
}

.professional-profile h4 {
  font-size: 18px;
  margin-top: 45px;
}

.professional-profile h4 span {
  color: #898989;
  font-size: .8em;
  position: relative;
}

.professional-profile .border-bottom {
  display: none;
}

.professional-profile h4 span:after {
  content: "";
  width: 10px;
  height: 10px;
  position: absolute;
  background: url(/static/images/icons/verified-icon.png);
  background-size: 100%;
  top: 4px;
  right: -12px;
}

.professional-profile .info {
  color: #555555;
  padding: 5px 0px;
}

.professional-profile .adress {
  color: #898989;
  font-size: 1.2em;
  line-height: 150%;
}

.professional-profile .h5-title {
  margin-bottom: 10px;
}

.professional-profile h5 {
  font-size: 16px;
  color: #2071B9;
  position: relative;
  display: inline-block;
}

.professional-profile h5:after {
  content: "";
  position: absolute;
  width: 100%;
  height: 2px;
  left: 0;
  bottom: -11px;
}

.professional-profile .map iframe {
  width: 100%;
  height: 230px;
  border-radius: 5px;
}

.professional-profile .white-space {
  width: 100%;
  height: 30px;
}

.professional-profile .agendar-consulta {
  font-size: .9em;
  background: #00ce18;
  border-radius: 50px;
  color: #FFFFFF;
  border: 1px solid #00ce18;
  padding: 6px 15px;
  cursor: pointer;
  margin: 30px 0px;
  float: left;
}

.professional-profile .agendar-consulta.mobile {
  display: none;
}

.professional-profile .agendar-consulta:hover {
  background: #FFFFFF;
  color: #00ce18;
  padding: 6px 10px 6px 20px;
}

.professional-profile .item {
  border-bottom: 1px solid #E5E7E7;
  padding: 15px 0px;
  color: #555555;
  font-size: 15px;
}

.professional-profile .item:last-child {
  border: none;
}

.professional-profile .item small {
  color: #898989;
  font-size: 13px;
}

.professional-profile .item .margin {
  width: 100%;
  height: 10px;
  float: left;
}

.professional-profile table {
  margin-top: 25px;
  color: #898989;
  text-align: center;
  cursor: default;
}

.professional-profile table th {
  color: #1384D8;
  text-align: center;
}

.professional-profile table td {
  border-radius: 30px;
}

.professional-profile table td:hover {
  background: #1384D8;
  color: #FFFFFF;
  cursor: pointer;
}

.professional-profile .gallery {
  width: 100%;
  height: auto;
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 30px;
}

.professional-profile .gallery .columns {
  -webkit-column-count: 2;
  -webkit-column-gap: 2%;
  -moz-column-count: 2;
  -moz-column-gap: 2%;
  column-count: 2;
  column-gap: 2%;
  width: 100%;
}

.professional-profile .gallery .columns div {
  display: inline-block;
}

.professional-profile .gallery .columns div img {
  width: 100%;
  height: auto;
  margin-bottom: 15px;
}
.thumbnail {
    display: block;
    width: 66px;
    padding: 4px;
    margin-bottom: 0px;
    line-height: 1.42857143;
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 4px;
    margin-left: 0px;
    -webkit-transition: border .2s ease-in-out;
    -o-transition: border .2s ease-in-out;
    transition: border .2s ease-in-out;
}
/* EndTop --*/

#intro .content {
    height: 220px;
    position: absolute;
    background: rgba(255, 255, 255, .85);
    border-radius: 5px;
    text-align: center;
    bottom: 79px;
}
.mb-cursor-pointer {
 cursor: pointer;
}
.no-undeline {
  text-decoration: none;
}
.p-15 {
  padding: 15px;
}
  .responsive-size {
    width: 49.333333%
  }
  .border-shadow {
    -webkit-box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.55);
    -moz-box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.55);
    box-shadow: 0px 3px 5px 1px rgba(0,0,0,0.55);
  }
  .cursor-point {
    cursor: pointer;
  }
.avatar img {
  border-radius: 50%;
  position: relative;
  left: -5px;
  margin-left: -30px;
  z-index: 1;
}

.avatar-company-professional img {
  border-radius: 50%;
  position: relative;
  left: -5px;
  margin-left: -30px;
  z-index: 1;
}

.avatar-company img {
    border-radius: 50%;
    position: relative;
    left: -5px;
    margin-left: -30px;
    z-index: 1;
}

.avatars {
  direction: rtl;
  text-align: left;
  padding-left: 70px;
}
.avatars-company {
  direction: rtl;
  text-align: left;
  padding-left: 16px;
}
.avatar-professional {
  z-index: 8;
  margin-top: 72px;
  margin-left: -58px;
  border-radius:50%;
  -webkit-box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
  -moz-box-shadow: 2px 2px 11px 0px rgba(50, 50, 25, 1);
  box-shadow:2px 2px 11px 0px rgba(50, 50, 25, 1);
}


@media (max-width:768px) {
  .professional-profile .info {
    color: #555555;
    padding: 5px 0px;
    font-size: 15px;
  }
  .professional-profile .adress {
    color: #898989;
    font-size: 1.0em;
    line-height: 180%;
  }

}

@media (max-width: 767px){
  .agendas .label-times  {
    color: #2071b9;
    margin-top: 40px;
  }
  .results .item h4 {
    padding: 0px;
  }

  .results .item .info {
    margin-top: 5px;
    color: #555555;
    padding: 0px;
}
  .m-top-15 {
    margin-top: 15px;
  }
  #planos, #consulta-particular {
    margin-top: 15px;
    padding: 0px 0px;
    font-size: 9px;
  }
  #planos span {
    display: inline-block;
    margin: 3px 2px;
    padding: 2px 15px;
    border: 1px solid #1384D8;
    color: #1384D8;
    border-radius: 50px;
    cursor: default;
    font-size: 9px;
  }
  .m-top-15px {
    margin-top: 15px;
  }
  hr {
    margin-top: 10px;
    margin-bottom: 20px;
    border: 0;
    border-top: 1px solid #eee;
  }
  #results h2 {
      font-weight: 300;
      font-size: 25px;
      position: relative;
      color: #333344;
      margin-bottom: 45px;
      text-align: center;
  }
  .responsive-size {
    width: 100%;
    height: 200px;
  }
  .avatar-company img {
    border-radius: 50%;
    position: relative;
    left: -5px;
    margin-left: -30px;
    z-index: 1;
    margin-top: -100px;
  }
  .avatar-professional {
    margin-top: 0px;
  }

  #apresentacao {
    padding: 30px 0px;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  #apresentacao .loader {
    position: relative;
    text-align: center;
    margin: 10px auto;
    font-size: 60px;
    color: #2080cd;
    margin-top: 100px;
  }

/* startTop */
.professional-public {
    background-color: #fff;
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: justify;
}

.professional-public h4 {
  font-size: 22px;
}
.professional-profile .profile-photo img {
  width: 60%;
  margin: 20px 10% 0px 10%;
  box-shadow: rgb(186, 190, 202) 0px 0px 0px 1px;
}
.professional-profile .adress {
  color: #898989;
  font-size: 0.9em;
  line-height: 150%;
}
.professional-profile .info {
    color: #555555;
    padding: 5px 0px;
    font-size: 13px;
}

.thumbnail {
  display: block;
  width: 20%;
  padding: 5px;
  margin-bottom: 0px;
  line-height: 1.42857143;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  margin-left: 13px;
  -webkit-transition: border .2s ease-in-out;
  -o-transition: border .2s ease-in-out;
  transition: border .2s ease-in-out;
}

/* EndTop --*/
}
</style>



// WEBPACK FOOTER //
// src/app/patient/profile-company/gadget/index.vue